import { t } from 'i18next';
import * as Yup from 'yup';

const multipleSessionSchema = (activeStep) =>
  Yup.object().shape({
    selectedOption:
      activeStep === 0
        ? Yup.string().required(t('multipleSession.errorMultipleSession'))
        : Yup.string(),
    selectedValues:
      activeStep === 1 ? Yup.array().min(1, t('multipleSession.errorAddmissionItem')) : Yup.array()
  });

export default multipleSessionSchema;
